import { FC, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { useOrganisationService } from 'src/pages/settings/organisation/use-organisation-service';
import { useAssignedOperators } from 'src/pages/shipper-admin/details/use-assigned-operators';
import { useFutureShipperUser } from 'src/pages/shipper-admin/details/use-future-shipper-user';
import { useShipper } from 'src/pages/shipper-admin/details/use-shipper';
import { useShipperUser } from 'src/pages/shipper-admin/details/use-shipper-user';
import { useShipperUserData } from 'src/pages/shipper-admin/details/use-shipper-user-data';

const Page = lazy(() => import('./page'));

export const ShipperUserDetails: FC = () => {
  const { oldUserId } = useParams<{ oldUserId: string }>();
  const shipper = useShipper();
  const shipperUser = useShipperUser(oldUserId!);
  const futureShipperUser = useFutureShipperUser(oldUserId!);
  const shipperUserData = useShipperUserData(oldUserId!);
  const assignedOperators = useAssignedOperators(shipperUserData);
  const organisationService = useOrganisationService();

  return (
    <Page
      shipper={shipper}
      shipperUser={shipperUser}
      futureShipperUser={futureShipperUser}
      shipperUserData={shipperUserData}
      assignedOperators={assignedOperators}
      organisationService={organisationService}
    />
  );
};
